import { Button, message, Switch, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppInput from "../../../components/AppInput";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import SelectInput from "../../../components/SelectInput";
import VoyageDetails from "../../../components/VoyageDetails";
import useUserData from "../../../hooks/useUserData";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import TextArea from "antd/es/input/TextArea";
import RequestFormModal2 from "../../../components/RequestFormModel_orb2";
import SecurityCodeModal from "../../../components/SecurityCodeModal";
import EditOilRecordLogPartTwoModal from "./component/OcodeEditEntry2";

function ViewOilRecordLog() {
  const navigate = useNavigate();
  const { oil_record_id } = useParams();
  const user = useUserData();
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState("");
  const [code, set_code] = useState("");
  const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [initialDocument, setInitialDocument] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [securitymodalVisible, setSecrityModalVisible] = useState(false);
  const { documentList, handleDocumentChange } = useDocumentUpload(initialDocument);

  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [child_id, set_child_id] = useState("");
  const [previous_log_date, set_Previous_Log_Date] = useState("");

  const LIST_OIL_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("orb_part", "2");
      post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.code_categories?.map((item) => {
            return {
              value: item?.id,
              label: `(${item?.value}) ` + item?.label,
            };
          });
          setCodeList(newRespones);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_OIL_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code_category_id", code_id);
      FORM_DATA.append("orb_part", "2");
      post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.subdetails?.map((item) => {
            return {
              value: item?.id,
              label: item?.sub_code_name,
              sub_code_name: item?.subdetails_child,
            };
          });
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      if (exists) {
        return prevItems.filter((item) => item.id !== value);
      } else {
        return [...prevItems, { id: value, value: "" }];
      }
    });
  };

  const handleInputChange = (id, inputValue) => {
    setSelectedItems((prevItems) =>
      prevItems?.map((item) => (item.id === id ? { ...item, value: inputValue } : item))
    );
  };

  const groupedOptions = codeItemList.flatMap((item) => {
    if (item.sub_code_name.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: item.sub_code_name.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: ` ${sub?.subdetails_child}`,
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label,
      };
    }
  });

  const VIEW_OIL_RECORD_LOGBOOK_APIS = () => {
    if (!oil_record_id) {
      console.warn("No oil_record_id found in params");
      return;
    }
    const FORM_DATA = new FormData();
    try {
      const decodedId = atob(oil_record_id);
      if (!decodedId || decodedId === "undefined" || decodedId === "null") {
        console.warn("Invalid oil_record_id after decoding:", decodedId);
        return;
      }
      FORM_DATA.append("record_id", decodedId);
    } catch (e) {
      console.error("Failed to decode oil_record_id:", e);
      return;
    }
    FORM_DATA.append("orb_part", "2");
    FORM_DATA.append("request_type", "view");
    post(ApiURL.view_update_orb_details_st, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const oilRecordData = res?.data || {};
        set_code(oilRecordData.code_category || "");
        set_date(oilRecordData.date || "");
        set_signature(oilRecordData.operation_details || "");
        setSubmitStatus(res?.submit_status || false);
        setInitialDocument(oilRecordData.files || []);
        set_child_id(res?.child_id);
        set_Previous_Log_Date(res?.last_date);
        let parsedSubDetails = [];
        const subDetailValues = oilRecordData.sub_detail_values;
        if (Array.isArray(subDetailValues)) {
          parsedSubDetails = subDetailValues;
        } else if (typeof subDetailValues === "string" && subDetailValues.trim() !== "") {
          try {
            parsedSubDetails = JSON.parse(subDetailValues);
          } catch (error) {
            console.error("Failed to parse sub_detail_values:", error);
          }
        }
        setSelectedItems(parsedSubDetails);
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    VIEW_OIL_RECORD_LOGBOOK_APIS();
    LIST_OIL_RECORD_CODE_API();
  }, []);

  useEffect(() => {
    if (code) {
      LIST_OIL_RECORD_ITEM_API(code);
    }
  }, [code]);

  const GET_DUCS_URL = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = GET_DUCS_URL(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  const reomveItem = async (file) => {
    const fileName = file.name;
    const FORM_DATA = new FormData();
    FORM_DATA.append("file_name", fileName);
    try {
      post(ApiURL.remove_file_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", "File removed successfully");
          VIEW_OIL_RECORD_LOGBOOK_APIS();
        } else {
          ErrorToast("Error", "Failed to remove file");
          console.error("Failed to remove file:", res?.message);
          return;
        }
      });
    } catch (error) {
      console.error("Error removing file:", error);
      ErrorToast("Error", "Failed to remove file");
      return;
    }
  };

  const CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX = (record_id, check_type) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", atob(record_id));
    FORM_DATA.append("chief_reviewed", check_type);
    FORM_DATA.append("orb_part", "2");
    post(ApiURL.update_single_checkbox_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success message !!", res?.message);
        navigate("/list-oil-record-log");
      } else {
        ErrorToast("Error message", res?.message);
      }
    });
  };

  useEffect(() => {
    if (checked) {
      setOpen(true);
    }
  }, [checked]);

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <br />
        <h3>Oil Record book Part 2 Information </h3>
        <br />
        <div className="row">
          <div className="col-6">
            <SelectInput
              disabled={submitStatus}
              label="Code"
              value={code}
              placeholder=" -- Selecte Code  -- "
              style={{ width: "100%" }}
              onChange={(value) => {
                set_code(value);
                setSelectedItems([]);
                LIST_OIL_RECORD_ITEM_API(value);
              }}
              options={codeList}
              errors={errors?.code}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              type="date"
              label="Date"
              placeholder="Date"
              value={date}
              onChange={(e) => set_date(e.target.value)}
              errors={errors.date}
              showInfo={code == 15}
              infoMessage="Current Date - When the missed entry is being logged"
              min={previous_log_date}
            />
          </div>
        </div>
        {code == 15 && (
          <div className="row" style={{ marginLeft: "5px", marginBottom: "7px" }}>
            <div style={{ marginRight: "5px" }}>
              <label>Do you want to record a missed operation entry (Yes / No)</label>
            </div>
            <Switch
              value={checked}
              onChange={(checked) => {
                setChecked(checked);
              }}
              checkedChildren="No"
              unCheckedChildren="Yes"
              style={{
                backgroundColor: checked ? "green" : "red",
              }}
            />
          </div>
        )}

        {code && (
          <div
            className="col-12"
            style={{
              lineHeight: "2",
              border: "1px solid #d9d9d9",
              borderRadius: "5px",
            }}
          >
            <strong className="form-label">Select Items:</strong>
            {groupedOptions.map((optionGroup, index) => (
              <div key={index} className="mb-3">
                {/* Main Label as Checkbox */}
                <div className="row align-items-center mb-2">
                  <div className="col-6">
                    <div className="form-check">
                      {optionGroup?.options?.length > 1 ? (
                        ""
                      ) : (
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={optionGroup.label}
                          checked={selectedItems.some((item) => item.id === optionGroup.value)}
                          onChange={() => handleCheckboxChange(optionGroup.value)}
                          id={`group-checkbox-${index}`}
                        />
                      )}
                      <label className="form-check-label" htmlFor={`group-checkbox-${index}`}>
                        {typeof optionGroup.label === "string" ? (
                          <strong>{optionGroup.label}</strong>
                        ) : (
                          <strong>{optionGroup.label.props.children}</strong>
                        )}
                      </label>
                    </div>
                  </div>

                  {/* Input Field for Main Label */}
                  <div className="col-6" style={{ marginLeft: "22px" }}>
                    {selectedItems.some((item) => item.id === optionGroup.value) && (
                      <TextArea
                        required
                        maxLength={1000}
                        className="form-control"
                        autoSize={{ minRows: 1 }}
                        placeholder={
                          typeof optionGroup.label === "string"
                            ? optionGroup.label
                            : optionGroup.label.props.children
                        }
                        value={
                          selectedItems.find((item) => item.id === optionGroup.value)?.value || ""
                        }
                        onChange={(e) => handleInputChange(optionGroup.value, e.target.value)}
                      />
                    )}
                  </div>
                </div>

                {/* Sub-options */}
                {optionGroup.options && (
                  <div className="ms-3" style={{ marginLeft: "30px", padding: "10px" }}>
                    {optionGroup.options.map((option) => (
                      <div key={option.value} className="row align-items-center mb-2">
                        {/* Left Side - Checkbox */}
                        <div className="col-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={option.value}
                              checked={selectedItems.some((item) => item.id === option.value)}
                              onChange={() => handleCheckboxChange(option.value)}
                              id={`checkbox-${option.value}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`checkbox-${option.value}`}
                            >
                              {option.label}
                            </label>
                          </div>
                        </div>

                        {/* Right Side - Input Field */}
                        <div className="col-6" style={{ padding: "5px" }}>
                          {selectedItems.some((item) => item.id === option.value) && (
                            <TextArea
                              required
                              maxLength={1000}
                              className="form-control"
                              autoSize={{ minRows: 3 }}
                              placeholder={option.label}
                              value={
                                selectedItems.find((item) => item.id === option.value)?.value || ""
                              }
                              onChange={(e) => handleInputChange(option.value, e.target.value)}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {errors?.sub_detail_values && (
          <span style={{ color: "red" }}>{errors?.sub_detail_values}</span>
        )}

        <div className="row" style={{ paddingTop: "10px" }}>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Name of operation incharge"
              placeholder="Name of operation incharge"
              value={signature}
              onChange={(e) => set_signature(e.target.value)}
              errors={errors.signature}
              showInfo={code == 15}
              infoMessage="Officer making this entry now"
            />
          </div>
          <div className="col-6">
            <div className="col-6">
              <div
                className="input-box"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                }}
              >
                <label>Select File</label>
                <Upload
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  multiple
                  fileList={documentList}
                  onChange={handleDocumentChange}
                  onPreview={handlePreviews}
                  beforeUpload={() => false}
                  listType="picture"
                  onRemove={reomveItem}
                >
                  <Button
                    icon={<UploadOutlined />}
                    type="primary"
                    style={{
                      borderRadius: "50%",
                      padding: "10px",
                      width: "40px",
                      height: "40px",
                      marginLeft: "10px",
                    }}
                  ></Button>
                </Upload>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RequestFormModal2
        visible={isModalVisible}
        record_id={atob(oil_record_id)}
        voyage_ids={staff_dashboard?.voyage_details?.[0]?.id}
        setModalVisible={setModalVisible}
        onCancel={() => {
          setModalVisible(!isModalVisible);
        }}
        routing={"/list-oil-record-log"}
        backtoedit={"backtoedit"}
        designation={user?.data?.designation}
      />
      <SecurityCodeModal
        record_id={atob(oil_record_id)}
        visible={securitymodalVisible}
        setModalVisible={setModalVisible}
        onCancel={() => setSecrityModalVisible(false)}
        onSuccess={() => {
          CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(oil_record_id, 1);
          setModalVisible(false);
        }}
        apiEndPoint={ApiURL.verify_security_code_st}
      />
      <EditOilRecordLogPartTwoModal
        visible={open}
        onClose={() => setOpen(false)}
        onSuccess={() => {}}
        child_id={child_id}
        oil_record_id={oil_record_id}
      />
    </>
  );
}

export default ViewOilRecordLog;
